"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageDialogReducer = exports.setMessageDialogState = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    isOpen: false,
    header: "",
    body: "",
};
var modalSlice = (0, toolkit_1.createSlice)({
    name: "messageDialog",
    initialState: initialState,
    reducers: {
        setMessageDialogState: function (state, action) {
            var _a = action.payload, isOpen = _a.isOpen, header = _a.header, body = _a.body, buttons = _a.buttons;
            state.isOpen = isOpen;
            state.header = header || "";
            state.body = body || "";
            state.buttons = buttons || [];
        },
    },
});
exports.setMessageDialogState = modalSlice.actions.setMessageDialogState;
exports.messageDialogReducer = modalSlice.reducer;
